import axios from 'axios';
import { STATE } from './STATE';

export default () => {
  return axios.create({
    baseURL: STATE.app.baseURL(process.env.REACT_APP_ENV || 'production')
  });
};
